const FeatureFlagConstants = {
  ZRM_MARKETING_COMPONENTS_ENABLED: 'ZRM_MARKETING_COMPONENTS_ENABLED',
  ZRM_AUTH_0_ENABLED: 'ZRM_AUTH_0_ENABLED',
} as const;

export default FeatureFlagConstants;
